<template>
  <b-modal :id="modalId" size="lg" centered hide-footer modal-class="sd-modal" title="Contacto">
    <template #modal-header>
      <img
        class="sd-modal-logo"
        :src="$store.getters.isDarkMode ? require('@/assets/img/logo_santo_domingo_dark.png') : require('@/assets/img/logo_santo_domingo.png')"
        :alt="$root.constantes.logo_nombre_sitio"
      />
      <button type="button" class="sd-modal-close" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <section v-if="direccion || mailIglesia || tlfIglesia" class="contacto-block">
      <p class="sd-eyebrow">Parroquia</p>
      <h2 class="contacto-title">Contacto</h2>

      <div class="contacto-grid">
        <a v-if="tlfIglesia" v-track:contacto="{ metodo: 'telefono', origen: 'modal_contacto' }" :href="`tel:${tlfIglesia}`" class="contacto-card">
          <span class="contacto-icon"><span class="material-symbols-outlined">call</span></span>
          <span class="contacto-label">Teléfono</span>
          <span class="contacto-value">{{ formatearTlf(tlfIglesia) }}</span>
        </a>
        <a v-if="mailIglesia" v-track:contacto="{ metodo: 'email', origen: 'modal_contacto' }" :href="`mailto:${mailIglesia}`" class="contacto-card">
          <span class="contacto-icon"><span class="material-symbols-outlined">mail</span></span>
          <span class="contacto-label">Correo</span>
          <span class="contacto-value">{{ mailIglesia }}</span>
        </a>
        <a v-if="direccion" v-track:contacto="{ metodo: 'mapa', origen: 'modal_contacto' }" :href="mapsUrl" target="_blank" rel="noopener" class="contacto-card">
          <span class="contacto-icon"><span class="material-symbols-outlined">location_on</span></span>
          <span class="contacto-label">Dirección</span>
          <span class="contacto-value">{{ direccion }}</span>
        </a>
      </div>
    </section>

    <section v-if="tlfCaritas || mailCaritas" class="contacto-block">
      <p class="sd-eyebrow">Cáritas</p>
      <h2 class="contacto-title">Cáritas Castrense Parroquial</h2>

      <div class="contacto-grid">
        <a v-if="tlfCaritas" v-track:contacto="{ metodo: 'telefono', origen: 'modal_contacto_caritas' }" :href="`tel:${tlfCaritas}`" class="contacto-card">
          <span class="contacto-icon"><span class="material-symbols-outlined">call</span></span>
          <span class="contacto-label">Teléfono</span>
          <span class="contacto-value">{{ formatearTlf(tlfCaritas) }}</span>
        </a>
        <a v-if="mailCaritas" v-track:contacto="{ metodo: 'email', origen: 'modal_contacto_caritas' }" :href="`mailto:${mailCaritas}`" class="contacto-card">
          <span class="contacto-icon"><span class="material-symbols-outlined">mail</span></span>
          <span class="contacto-label">Correo</span>
          <span class="contacto-value">{{ mailCaritas }}</span>
        </a>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  name: "modalContacto",
  props: ["modalId"],
  data() {
    const c = this.$root.constantes;
    return {
      mailIglesia: c.email.iglesia,
      tlfIglesia: c.tlf.iglesia,
      direccion: (c.direccion || "").trim(),
      mailCaritas: c.email.caritas,
      tlfCaritas: c.tlf.caritas,
    };
  },
  computed: {
    mapsUrl() {
      return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(this.direccion);
    },
  },
  methods: {
    formatearTlf(tlf) {
      const m = (tlf || "").match(/^(\+34)(\d{3})(\d{2})(\d{2})(\d{2})$/);
      return m ? `${m[1]} ${m[2]} ${m[3]} ${m[4]} ${m[5]}` : tlf;
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.contacto-block + .contacto-block {
  margin-top: 32px;
  padding-top: 28px;
  border-top: 1px solid var(--sd-border);
}

.contacto-title {
  margin: 0 0 18px;
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--sd-text);
}

.contacto-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.contacto-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 18px;
  border: 1px solid var(--sd-border);
  border-radius: 16px;
  background: var(--sd-surface-2);
  color: var(--sd-text);
  text-decoration: none;
  transition: border-color 0.15s, transform 0.15s;
}

.contacto-card:hover {
  border-color: var(--sd-primary);
  color: var(--sd-text);
  text-decoration: none;
  transform: translateY(-2px);
}

.contacto-icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  margin-bottom: 8px;
  border-radius: 12px;
  background: var(--sd-primary-soft);
}

.contacto-icon .material-symbols-outlined {
  font-size: 22px;
  color: var(--sd-primary);
}

.contacto-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sd-muted);
}

.contacto-value {
  font-weight: 600;
  color: var(--sd-text);
  word-break: break-word;
}
</style>
